
(function () {
  if (window.CustomCartUpsellsStableSliderInit) return;
  window.CustomCartUpsellsStableSliderInit = true;

  var lastSignature = null;
  var renderTimer = null;
  var rendering = false;
  var queued = false;
  var boundCartForm = null;
  var cartFormObserver = null;
  var rootObserver = null;
  var revealStyleInjected = false;

  function ensureRevealStyle() {
    if (revealStyleInjected) return;
    revealStyleInjected = true;

    var style = document.createElement("style");
    style.setAttribute("data-cart-upsells-reveal-style", "true");
    style.textContent =
      '[data-cart-upsells-root][data-upsells-js-ready="0"] [data-cart-upsells-list]{opacity:0;pointer-events:none;}' +
      '[data-cart-upsells-root][data-upsells-js-ready="1"] [data-cart-upsells-list]{opacity:1;transition:opacity .18s ease;}';
    document.head.appendChild(style);
  }

  function getUpsellsRoots() {
    return Array.prototype.slice.call(
      document.querySelectorAll("[data-cart-upsells-root]")
    );
  }

  function getUpsellsRoot() {
    var roots = getUpsellsRoots();
    if (!roots.length) return null;

    for (var i = 0; i < roots.length; i++) {
      var el = roots[i];
      if (el && el.getClientRects && el.getClientRects().length) return el;
    }

    return roots[0];
  }

  function getCartFormEl() {
    return document.getElementById("AjaxCartForm") || document.querySelector("cart-form") || null;
  }

  function fetchCart() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store"
    })
      .then(function (r) {
        return r.ok ? r.json() : { items: [] };
      })
      .catch(function () {
        return { items: [] };
      });
  }

  function cartSignature(cart) {
    if (!cart || !cart.items) return "";
    var ids = cart.items.map(function (i) {
      return i.product_id + "x" + i.quantity;
    }).join("|");
    return cart.item_count + "::" + ids;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === "number" ? precision : 2;
    thousands = typeof thousands === "string" ? thousands : ",";
    decimal = typeof decimal === "string" ? decimal : ".";

    if (isNaN(number) || number === null) return "0";

    var fixed = (number / 100).toFixed(precision);
    var parts = fixed.split(".");
    var dollars = parts[0];
    var cents = parts[1] ? decimal + parts[1] : "";

    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(dollars)) {
      dollars = dollars.replace(rgx, "$1" + thousands + "$2");
    }

    return dollars + cents;
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, format);
    }

    if (typeof cents === "string") cents = cents.replace(".", "");

    var formatString =
      format ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var placeholder = match ? match[1] : "amount";
    var value = "";

    switch (placeholder) {
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0, ",", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ", ".");
        break;
      default:
        value = formatWithDelimiters(cents, 2, ",", ".");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function moneyNodeMarkup(amount, moneyFormat) {
    return '<span data-upsells-money-node><span class="money">' + formatMoney(amount, moneyFormat) + "</span></span>";
  }

  function buildPriceHtml(price, compareAt, moneyFormat) {
    if (compareAt && compareAt > price) {
      return (
        '<span class="cart-upsells__price-old">' + moneyNodeMarkup(compareAt, moneyFormat) + "</span>" +
        '<span class="cart-upsells__price-new">' + moneyNodeMarkup(price, moneyFormat) + "</span>"
      );
    }

    return (
      '<span class="cart-upsells__price-regular">' + moneyNodeMarkup(price, moneyFormat) + "</span>"
    );
  }

  function moneyNodesReady(root) {
    if (!root) return true;

    var nodes = root.querySelectorAll("[data-upsells-money-node]");
    if (!nodes.length) return true;

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var text = (node.textContent || "").trim();

      if (text.indexOf("<span") !== -1 || text.indexOf("</span") !== -1) {
        return false;
      }

      if (node.querySelector(".glc-money")) {
        continue;
      }

      if (node.querySelector(".money")) {
        continue;
      }

      if (!/\d/.test(text)) {
        return false;
      }
    }

    return true;
  }

  function queueReveal(root, forceRefresh) {
    if (!root) return;

    var shouldForce = forceRefresh || root.dataset.upsellsPendingRefresh === "1";

    if (root.dataset.upsellsHydrated === "1" && !shouldForce) {
      root.dataset.upsellsJsReady = "1";
      return;
    }

    if (root._upsellsRevealTimer) {
      clearTimeout(root._upsellsRevealTimer);
    }

    root.dataset.upsellsJsReady = "0";

    var tries = 0;
    var maxTries = 40;
    var delay = 50;
    var startedAt = Date.now();
    var minWait = shouldForce ? 220 : 140;

    function check() {
      tries += 1;

      var elapsed = Date.now() - startedAt;
      var ready = moneyNodesReady(root) && elapsed >= minWait;

      if (ready || tries >= maxTries) {
        root.dataset.upsellsJsReady = "1";
        root.dataset.upsellsHydrated = "1";
        root.dataset.upsellsPendingRefresh = "0";
        return;
      }

      root._upsellsRevealTimer = setTimeout(check, delay);
    }

    check();
  }

  function markRootsForRefresh() {
    getUpsellsRoots().forEach(function (root) {
      if (!root) return;
      root.dataset.upsellsPendingRefresh = "1";
      if (root.dataset.upsellsHydrated === "1") {
        root.dataset.upsellsJsReady = "0";
      }
    });
  }

  function getShopRoot() {
    var root = "/";
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
    return root.replace(/\/?$/, "/");
  }

  function getRecommendationsUrl(productId, intent, limit) {
    return (
      getShopRoot() +
      "recommendations/products.json?product_id=" +
      encodeURIComponent(productId) +
      "&intent=" +
      encodeURIComponent(intent) +
      "&limit=" +
      encodeURIComponent(limit * 3)
    );
  }

  function fetchRecommendationsForProduct(productId, intent, limit) {
    return fetch(getRecommendationsUrl(productId, intent, limit), {
      credentials: "same-origin",
      cache: "no-store"
    })
      .then(function (r) {
        return r.ok ? r.json() : { products: [] };
      })
      .catch(function () {
        return { products: [] };
      });
  }

  function getCustomProductsFromRoot(root) {
    if (!root) return [];
    var script = root.querySelector("[data-upsells-custom-products]");
    if (!script) return [];

    try {
      var parsed = JSON.parse(script.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function setRootVisible(root, visible) {
    if (!root) return;
    root.hidden = !visible;
    root.style.display = visible ? "" : "none";

    if (!visible) {
      root.dataset.upsellsJsReady = "1";
      root.dataset.upsellsPendingRefresh = "0";
    }
  }

  function getSliderState(root) {
    if (!root._upsellsSliderState) {
      root._upsellsSliderState = {
        index: 0,
        count: 0,
        dragOffset: 0,
        isDragging: false,
        startX: 0,
        startY: 0,
        lockAxis: null
      };
    }
    return root._upsellsSliderState;
  }

  function updateSlider(root, options) {
    if (!root) return false;

    var opts = options || {};
    var track = root.querySelector("[data-cart-upsells-list]");
    var viewport = root.querySelector(".cart-upsells__viewport");
    if (!track || !viewport) return false;

    var slides = track.querySelectorAll(".cart-upsells__slide");
    var prev = root.querySelector("[data-upsells-prev]");
    var next = root.querySelector("[data-upsells-next]");
    var state = getSliderState(root);

    state.count = slides.length;

    if (!slides.length) return false;

    if (state.index > state.count - 1) {
      state.index = Math.max(0, state.count - 1);
    }

    if (state.index < 0) {
      state.index = 0;
    }

    var viewportWidth = viewport.clientWidth || root.clientWidth || 0;
    if (!viewportWidth || viewportWidth < 20) {
      return false;
    }

    var dragOffset = typeof opts.dragOffset === "number" ? opts.dragOffset : 0;
    var animate = opts.animate !== false;

    slides.forEach(function (slide) {
      slide.style.width = viewportWidth + "px";
      slide.style.minWidth = viewportWidth + "px";
      slide.style.maxWidth = viewportWidth + "px";
      slide.style.flex = "0 0 " + viewportWidth + "px";
      slide.style.boxSizing = "border-box";
    });

    track.style.width = viewportWidth * state.count + "px";
    track.style.transition = animate ? "transform .28s ease" : "none";
    track.style.transform =
      "translate3d(" + (-state.index * viewportWidth + dragOffset) + "px, 0, 0)";

    var disableAll = state.count <= 1;

    if (prev) {
      prev.disabled = disableAll || state.index === 0;
      prev.classList.toggle("is-disabled", prev.disabled);
    }

    if (next) {
      next.disabled = disableAll || state.index >= state.count - 1;
      next.classList.toggle("is-disabled", next.disabled);
    }

    return true;
  }

  function resetSlider(root) {
    var state = getSliderState(root);
    state.index = 0;
    state.dragOffset = 0;
    state.isDragging = false;
    state.lockAxis = null;
    updateSlider(root, { animate: false, dragOffset: 0 });
  }

  function relayoutSlider(root, tries, resetToFirst) {
    if (!root) return;

    var attempts = typeof tries === "number" ? tries : 8;
    var currentTry = 0;

    function tick() {
      if (!root || root.hidden) return;

      var state = getSliderState(root);
      if (resetToFirst) {
        state.index = 0;
        state.dragOffset = 0;
        state.isDragging = false;
        state.lockAxis = null;
      }

      var ok = updateSlider(root, {
        animate: false,
        dragOffset: 0
      });

      if (!ok && currentTry < attempts) {
        currentTry += 1;
        setTimeout(function () {
          requestAnimationFrame(tick);
        }, 80);
      }
    }

    requestAnimationFrame(tick);
  }

  function setupViewportObserver(root) {
    if (!root || root._upsellsViewportObserverBound || !window.ResizeObserver) return;

    var viewport = root.querySelector(".cart-upsells__viewport");
    if (!viewport) return;

    var observer = new ResizeObserver(function () {
      relayoutSlider(root, 4, false);
    });

    observer.observe(viewport);

    root._upsellsViewportObserver = observer;
    root._upsellsViewportObserverBound = true;
  }

  function bindTouchSlider(root) {
    if (!root || root._upsellsTouchBound) return;

    var viewport = root.querySelector(".cart-upsells__viewport");
    var track = root.querySelector("[data-cart-upsells-list]");
    if (!viewport || !track) return;

    var state = getSliderState(root);

    function onTouchStart(event) {
      if (!event.touches || event.touches.length !== 1) return;
      if (state.count <= 1) return;

      state.isDragging = true;
      state.startX = event.touches[0].clientX;
      state.startY = event.touches[0].clientY;
      state.dragOffset = 0;
      state.lockAxis = null;
      track.style.transition = "none";
    }

    function onTouchMove(event) {
      if (!state.isDragging || !event.touches || event.touches.length !== 1) return;

      var currentX = event.touches[0].clientX;
      var currentY = event.touches[0].clientY;
      var dx = currentX - state.startX;
      var dy = currentY - state.startY;

      if (state.lockAxis === null) {
        if (Math.abs(dx) < 4 && Math.abs(dy) < 4) return;
        state.lockAxis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
      }

      if (state.lockAxis !== "x") return;

      event.preventDefault();

      var atFirst = state.index === 0 && dx > 0;
      var atLast = state.index >= state.count - 1 && dx < 0;
      var resistance = atFirst || atLast ? 0.35 : 1;

      state.dragOffset = dx * resistance;
      updateSlider(root, { animate: false, dragOffset: state.dragOffset });
    }

    function onTouchEnd() {
      if (!state.isDragging) return;

      state.isDragging = false;

      var width = viewport.clientWidth || 1;
      var threshold = Math.min(90, width * 0.18);

      if (Math.abs(state.dragOffset) > threshold) {
        if (state.dragOffset < 0 && state.index < state.count - 1) {
          state.index += 1;
        } else if (state.dragOffset > 0 && state.index > 0) {
          state.index -= 1;
        }
      }

      state.dragOffset = 0;
      state.lockAxis = null;
      updateSlider(root, { animate: true, dragOffset: 0 });
    }

    viewport.addEventListener("touchstart", onTouchStart, { passive: true });
    viewport.addEventListener("touchmove", onTouchMove, { passive: false });
    viewport.addEventListener("touchend", onTouchEnd, { passive: true });
    viewport.addEventListener("touchcancel", onTouchEnd, { passive: true });

    root._upsellsTouchBound = true;
  }

  function updateUpsellPriceFromSelect(selectEl) {
    if (!selectEl) return;

    var card = selectEl.closest(".cart-upsells__item");
    if (!card) return;

    var priceWrap = card.querySelector(".cart-upsells__price");
    if (!priceWrap) return;

    var root = card.closest("[data-cart-upsells-root]");
    var moneyFormat =
      (root && root.getAttribute("data-upsells-money-format")) ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";

    var opt = selectEl.options[selectEl.selectedIndex];
    if (!opt) return;

    var price = parseInt(opt.getAttribute("data-price") || "0", 10);
    var compareAt = parseInt(opt.getAttribute("data-compare-at") || "0", 10);

    if (root && root.dataset.upsellsHydrated === "1") {
      root.dataset.upsellsPendingRefresh = "1";
    }

    priceWrap.innerHTML = buildPriceHtml(price, compareAt, moneyFormat);

    if (root) {
      queueReveal(root, true);
    }
  }

  function buildSlidesHtml(products, inCartProductIds, moneyFormat, limit) {
    var usedIds = new Set();
    var picked = [];

    products.forEach(function (p) {
      if (!p || p.available === false) return;
      if (inCartProductIds.indexOf(p.id) !== -1) return;
      if (usedIds.has(p.id)) return;
      if (picked.length >= limit) return;

      usedIds.add(p.id);
      picked.push(p);
    });

    if (!picked.length) return "";

    return picked.map(function (p) {
      var img = p.featured_image || (p.images && p.images[0]);
      var imgUrl = null;

      if (img && typeof img === "string") {
        imgUrl = img.replace(/_(\d+x\d+|x\d+)\./, "_220x.");
      } else if (img && img.src) {
        imgUrl = img.src;
      } else if (img && img.url) {
        imgUrl = img.url;
      }

      var title = p.title || "";
      var words = title.split(" ").filter(function (w) { return w.length; });
      var shortTitle = words.slice(0, 5).join(" ");
      if (words.length > 5) shortTitle += "…";

      var variants = p.variants || [];
      var selectedVariant = null;

      for (var i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].available) {
          selectedVariant = variants[i];
          break;
        }
      }

      if (!selectedVariant && variants.length) {
        selectedVariant = variants[0];
      }

      var basePrice = selectedVariant && selectedVariant.price != null ? selectedVariant.price : p.price;
      var baseCompareAt = selectedVariant && selectedVariant.compare_at_price != null
        ? selectedVariant.compare_at_price
        : p.compare_at_price;

      var priceHtml = buildPriceHtml(basePrice, baseCompareAt, moneyFormat);

      var hasMultipleVariants = variants.length > 1;
      var selectedVariantId = selectedVariant && selectedVariant.id;
      var handle = p.handle || "";
      var productUrl = p.url || (handle ? getShopRoot() + "products/" + handle : "#");

      var selectorHtml = "";
      if (hasMultipleVariants) {
        selectorHtml += '<div class="cart-upsells__variant-row">';
        selectorHtml += '<select class="cart-upsells__variant-select" data-upsell-variant-select>';
        variants.forEach(function (v) {
          if (!v) return;
          selectorHtml +=
            '<option value="' + v.id + '"' +
            (selectedVariantId && String(v.id) === String(selectedVariantId) ? " selected" : "") +
            ' data-price="' + (v.price || 0) + '"' +
            ' data-compare-at="' + (v.compare_at_price || 0) + '"' +
            (v.available === false ? " disabled" : "") +
            ">" +
            (v.public_title || v.title || "") +
            "</option>";
        });
        selectorHtml += "</select></div>";
      }

      var buttonHtml = "";
      if (!hasMultipleVariants && selectedVariant && selectedVariant.id) {
        buttonHtml =
          '<button type="button" class="cart-upsells__add" data-cart-upsell-add data-variant-id="' +
          selectedVariant.id +
          '"><span class="cart-upsells__add-icon">+</span></button>';
      } else {
        buttonHtml =
          '<button type="button" class="cart-upsells__add" data-cart-upsell-add><span class="cart-upsells__add-icon">+</span></button>';
      }

      return (
        '<div class="cart-upsells__slide">' +
          '<div class="cart-upsells__item">' +
            '<div class="cart-upsells__row">' +
              '<a href="' + productUrl + '" class="cart-upsells__media" data-instant>' +
                (imgUrl ? '<img src="' + imgUrl + '" alt="' + shortTitle.replace(/"/g, "&quot;") + '">' : "") +
              "</a>" +
              '<div class="cart-upsells__content">' +
                '<a href="' + productUrl + '" class="cart-upsells__title" data-instant>' + shortTitle + "</a>" +
                '<div class="cart-upsells__price">' + priceHtml + "</div>" +
                (selectorHtml || "") +
              "</div>" +
              buttonHtml +
            "</div>" +
          "</div>" +
        "</div>"
      );
    }).join("");
  }

  function waitForCartRefresh(timeout) {
    return new Promise(function (resolve) {
      var done = false;
      var observer = null;
      var target = getCartFormEl() || document.documentElement;

      function finish() {
        if (done) return;
        done = true;
        if (observer) observer.disconnect();
        resolve();
      }

      observer = new MutationObserver(function () {
        finish();
      });

      observer.observe(target, {
        childList: true,
        subtree: true,
        characterData: true
      });

      setTimeout(finish, timeout || 1200);
    });
  }

  function scheduleRender(force, delay) {
    if (force) {
      lastSignature = null;
      markRootsForRefresh();
    }

    if (rendering) {
      queued = true;
      return;
    }

    clearTimeout(renderTimer);
    renderTimer = setTimeout(function () {
      renderCartUpsells();
    }, typeof delay === "number" ? delay : (force ? 160 : 80));
  }

  function renderCartUpsells() {
    var root = getUpsellsRoot();
    if (!root) return;

    var listEl = root.querySelector("[data-cart-upsells-list]");
    if (!listEl) return;

    rendering = true;

    var intent = root.getAttribute("data-upsells-intent") || "complementary";
    var limit = parseInt(root.getAttribute("data-upsells-limit") || "3", 10);
    var moneyFormat =
      root.getAttribute("data-upsells-money-format") ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}";

    fetchCart()
      .then(function (cart) {
        var sig = cartSignature(cart);

        if (sig === lastSignature && listEl.children.length) {
          bindTouchSlider(root);
          setupViewportObserver(root);
          relayoutSlider(root, 8, false);
          queueReveal(root, root.dataset.upsellsPendingRefresh === "1");

          rendering = false;
          if (queued) {
            queued = false;
            scheduleRender(false);
          }
          return;
        }

        lastSignature = sig;

        if (!cart || !cart.items || !cart.items.length) {
          setRootVisible(root, false);
          listEl.innerHTML = "";
          rendering = false;
          return;
        }

        var inCartProductIds = cart.items.map(function (i) {
          return i.product_id;
        });

        function finish(products) {
          var html = buildSlidesHtml(products || [], inCartProductIds, moneyFormat, limit);

          if (!html) {
            setRootVisible(root, false);
            listEl.innerHTML = "";
            rendering = false;
            return;
          }

          setRootVisible(root, true);
          root.dataset.upsellsPendingRefresh = "1";
          root.dataset.upsellsJsReady = "0";
          listEl.innerHTML = html;

          listEl.querySelectorAll("[data-upsell-variant-select]").forEach(function (select) {
            updateUpsellPriceFromSelect(select);
          });

          bindTouchSlider(root);
          setupViewportObserver(root);
          resetSlider(root);
          relayoutSlider(root, 8, true);
          setTimeout(function () {
            relayoutSlider(root, 4, false);
          }, 180);

          queueReveal(root, true);

          rendering = false;

          if (queued) {
            queued = false;
            scheduleRender(false);
          }
        }

        if (intent === "custom") {
          finish(getCustomProductsFromRoot(root));
          return;
        }

        var allRecs = [];
        var productIds = inCartProductIds.slice();
        var idx = 0;

        function step() {
          if (idx >= productIds.length || allRecs.length >= limit * 3) {
            finish(allRecs);
            return;
          }

          var pid = productIds[idx++];
          fetchRecommendationsForProduct(pid, intent, limit)
            .then(function (data) {
              if (data && Array.isArray(data.products)) {
                allRecs = allRecs.concat(data.products);
              }
              step();
            })
            .catch(function () {
              step();
            });
        }

        step();
      })
      .catch(function () {
        rendering = false;
        if (root) {
          root.dataset.upsellsJsReady = "1";
          root.dataset.upsellsPendingRefresh = "0";
        }
      });
  }

  function onCartUpdated() {
    scheduleRender(true, 160);
  }

  function bindCartFormEvents() {
    var cartForm = getCartFormEl();
    if (!cartForm || cartForm === boundCartForm) return;

    if (boundCartForm) {
      boundCartForm.removeEventListener("cart-updated", onCartUpdated);
    }

    boundCartForm = cartForm;
    boundCartForm.addEventListener("cart-updated", onCartUpdated);
  }

  function setupCartFormObserver() {
    var cartForm = getCartFormEl();
    if (!cartForm) return;

    if (cartFormObserver) {
      cartFormObserver.disconnect();
      cartFormObserver = null;
    }

    cartFormObserver = new MutationObserver(function () {
      bindCartFormEvents();
      scheduleRender(true, 160);
    });

    cartFormObserver.observe(cartForm, {
      childList: true,
      subtree: true
    });
  }

  function setupRootObserver() {
    if (rootObserver) return;

    rootObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        (mutation.addedNodes || []).forEach(function (node) {
          if (!node || node.nodeType !== 1) return;

          if (
            (node.matches && (node.matches("#AjaxCartForm") || node.matches("[data-cart-upsells-root]"))) ||
            (node.querySelector && (node.querySelector("#AjaxCartForm") || node.querySelector("[data-cart-upsells-root]")))
          ) {
            bindCartFormEvents();
            setupCartFormObserver();
            scheduleRender(true, 160);
          }
        });
      });
    });

    rootObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function refreshCartUI() {
    if (typeof window.refreshCart === "function") {
      try {
        window.refreshCart();
      } catch (e) {}

      return waitForCartRefresh(1200).then(function () {
        bindCartFormEvents();
        setupCartFormObserver();
        scheduleRender(true, 180);
      });
    }

    scheduleRender(true, 180);
    return Promise.resolve();
  }

  function parseJsonResponse(response) {
    return response.json().catch(function () {
      return {};
    }).then(function (data) {
      if (!response.ok) throw data || {};
      return data;
    });
  }

  document.addEventListener("click", function (event) {
    var prevBtn = event.target.closest("[data-upsells-prev]");
    if (prevBtn) {
      event.preventDefault();
      var prevRoot = prevBtn.closest("[data-cart-upsells-root]");
      var prevState = getSliderState(prevRoot);
      prevState.index -= 1;
      updateSlider(prevRoot, { animate: true, dragOffset: 0 });
      return;
    }

    var nextBtn = event.target.closest("[data-upsells-next]");
    if (nextBtn) {
      event.preventDefault();
      var nextRoot = nextBtn.closest("[data-cart-upsells-root]");
      var nextState = getSliderState(nextRoot);
      nextState.index += 1;
      updateSlider(nextRoot, { animate: true, dragOffset: 0 });
      return;
    }

    var button = event.target.closest("[data-cart-upsell-add]");
    if (!button) return;

    var variantId = button.getAttribute("data-variant-id");

    if (!variantId) {
      var card = button.closest(".cart-upsells__item");
      if (card) {
        var select = card.querySelector("[data-upsell-variant-select]");
        if (select) variantId = select.value;
      }
    }

    if (!variantId) return;

    event.preventDefault();
    button.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    })
      .then(parseJsonResponse)
      .then(function () {
        return refreshCartUI();
      })
      .catch(function (err) {
        console.warn("Upsell add error:", err);
      })
      .finally(function () {
        button.disabled = false;
      });
  });

  document.addEventListener("change", function (event) {
    var select = event.target.closest("[data-upsell-variant-select]");
    if (!select) return;
    updateUpsellPriceFromSelect(select);
  });

  document.addEventListener("shopify:section:load", function () {
    bindCartFormEvents();
    setupCartFormObserver();
    scheduleRender(true, 160);
  });

  ["cart:updated", "cart:refresh", "cart:change"].forEach(function (evt) {
    document.addEventListener(evt, function () {
      bindCartFormEvents();
      setupCartFormObserver();
      scheduleRender(true, 160);
    });
  });

  window.addEventListener("resize", function () {
    getUpsellsRoots().forEach(function (root) {
      updateSlider(root, { animate: false, dragOffset: 0 });
    });
  });

  window.addEventListener("visibilitychange", function () {
    if (document.visibilityState !== "visible") return;
    getUpsellsRoots().forEach(function (root) {
      relayoutSlider(root, 6, false);
    });
  });

  window.addEventListener("focus", function () {
    getUpsellsRoots().forEach(function (root) {
      relayoutSlider(root, 6, false);
    });
  });

  window.addEventListener("pageshow", function () {
    getUpsellsRoots().forEach(function (root) {
      relayoutSlider(root, 6, false);
    });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      ensureRevealStyle();
      bindCartFormEvents();
      setupCartFormObserver();
      setupRootObserver();
      scheduleRender(true, 160);
    });
  } else {
    ensureRevealStyle();
    bindCartFormEvents();
    setupCartFormObserver();
    setupRootObserver();
    scheduleRender(true, 160);
  }
})();
